<template>
  <table :class="$style['pt-invoice-message']">
      <pt-form-list-item label="发票类型：" :required="true" :widthMax="maxWidth">
          <wt-radio :radios="invoiceProvideType" v-model="form.invoiceType" data-vv-as="发票类型" name="name"
              v-validate="'required'"></wt-radio>
      </pt-form-list-item>
      <template v-if="form.invoiceType=='MAILING'">
          <pt-form-list-item label="联系人：" required :widthMax="maxWidth">
              <wt-input v-model="form.contacts" data-vv-as="联系人" name="name"
              v-validate="'required'"></wt-input>
          </pt-form-list-item>
          <pt-form-list-item label="手机号码：" required :widthMax="maxWidth">
              <wt-input v-model="form.phone" data-vv-as="手机号码" name="name"
              v-validate="'required'"></wt-input>
          </pt-form-list-item>
          <pt-form-list-item label="地址：" required :widthMax="maxWidth">
              <pt-address-select v-model="address" required clearable @change="change"  data-vv-as="发票地址" name="name"
              v-validate="'required'" ref="address" :validateText="addressValidateText"></pt-address-select>
          </pt-form-list-item>
      </template>
      <pt-form-list-item label="收票人邮箱：" :required="true" :widthMax="maxWidth"  v-else>
          <wt-input v-model="form.email" data-vv-as="收票人邮箱" name="name" type="email"
              v-validate="'required|email'"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="发票抬头类型：" :required="true" :widthMax="maxWidth">
          <wt-radio :radios="invoiceObject" v-model="form.titleType" data-vv-as="发票抬头类型" name="name"
              v-validate="'required'"></wt-radio>
      </pt-form-list-item>
    <template v-if="form.titleType=='ORGANIZATIONAL'" >
        <pt-form-list-item label="公司名称：" required :widthMax="maxWidth">
            <wt-input v-model="form.name" :required="true"  data-vv-as="公司名称" name="name"
              v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="纳税人识别号：" :required="true" :widthMax="maxWidth">
            <wt-input v-model="form.taxNumber"  :required="true"  data-vv-as="纳税人识别号" name="name"
              v-validate="'required'"></wt-input>
        </pt-form-list-item>
    </template>
    <pt-form-list-item label="个人名称：" :required="true"  v-else :widthMax="maxWidth">
        <wt-input v-model="form.name" data-vv-as="个人名称" name="name"
              v-validate="'required'"></wt-input>
    </pt-form-list-item>
  </table>
</template>

<script>
// 组件class前缀
import { invoiceProvideTypesDo, invoiceObject } from 'json/mall-options'
import ptAddressSelect from 'cps/base/pt-address-select/withData'
import { isEmptyObject } from '@/utils/formUtils'
import formMixins from 'mixins/form'
const prefixCls = 'pt-invoice-message'
export default {
  mixins: [formMixins],
  name: 'pt-invoice-message',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptAddressSelect
  },
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    maxWidth: {
      type: [Number, String],
      default: ''
    }
  },
  data () {
    return {
      invoiceProvideType: invoiceProvideTypesDo,
      invoiceObject: invoiceObject,
      form: {
        invoiceType: 'ELECTRIC',
        titleType: 'PERSONAL'
      },
      addressValidateText: {
        province: '发票地址：省',
        city: '发票地址：市',
        district: '发票地址：区',
        address: '发票详细地址'
      },
      address: {}
    }
  },
  watch: {
    value: {
      handler: function (val) {
        if (!isEmptyObject(val)) {
          this.form = JSON.parse(JSON.stringify(val))
          let { provinceGbCode, cityGbCode, districtGbCode, postAddress } = JSON.parse(JSON.stringify(val))
          this.address = { provinceGbCode, cityGbCode, districtGbCode, postAddress }
        }
      },
      deep: true,
      immediate: true
    },
    form: {
      handler: function (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    change (val) {
      this.form = { ...this.form, ...val }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-invoice-message{
    width: 600px;
    padding: 0 20px;
}
</style>
